import React from "react";

function Partnerships() {
  return (
    <section className="py-20 w-full bg-[#122B3E] text-white">
      {/* Section Header */}
      <div className="flex justify-center items-center">
        <div className="text-center">
          <h2 className="text-2xl md:text-3xl mb-2 font-semibold">Our Partners</h2>
          <div className="border-b-4 border-green-600 w-[90px] mx-auto" />
        </div>
      </div>

      {/* Content */}
      <div className="flex justify-center items-center w-full md:w-[70%] max-w-[1280px] mx-auto px-4 2xl:px-0 mt-8">
        <h3 className="text-center text-base sm:text-lg font-normal">
          We are open to work with any registered groups or organisations that
          we share the same vision with.
        </h3>
      </div>
    </section>
  );
}

export default Partnerships;
